<template>
    <form-template remarkOnly>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Amount</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <biller-input placeholder="Input Account Number" />
        </div>
        <div
            class="col-span-4 grid grid-cols-4 row-gap-5  md:row-gap-10 items-center"
            v-for="field in fields"
            :key="field.label"
        >
            <div class="col-span-4 md:col-span-1">
                <p class="text-smoke-dark text-sm">{{ field.label }}</p>
            </div>
            <div class="col-span-4 md:col-span-3 relative">
                <biller-input :placeholder="field.placeholder" />
            </div>
        </div>
    </form-template>
</template>

<script>
export default {
    data() {
        return {
            fields: [
                {
                    label: 'Amount',
                    placeholder: 'Input Amount',
                },
                {
                    label: 'First Name',
                    placeholder: 'Input Recipient’s First Name',
                },
                {
                    label: 'Last Name',
                    placeholder: 'Input Recipient’s Last Name',
                },
                {
                    label: 'Recipient’s Email',
                    placeholder: 'Input Recipient’s Email',
                },
                {
                    label: 'Country',
                    placeholder: 'Select Recipient’s Country',
                },
                {
                    label: 'Bank Name',
                    placeholder: 'Input Bank Name',
                },
                {
                    label: 'IBAN/Account Number',
                    placeholder: 'Input IBAN/Account Number',
                },
                {
                    label: 'Swift Code',
                    placeholder: 'Input Swift Code',
                },
                {
                    label: 'Sort Code',
                    placeholder: 'Input Bank Routing Number/Sort Code',
                },
                {
                    label: 'Bank Address',
                    placeholder: 'Input Bank Address',
                },
            ],
        }
    },
}
</script>

<style></style>
